import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from './style.module.less'
import Table from './Table'
import { Action } from 'hljd'

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getStatusCount()
  }
  render() {
    const { key, statusCount } = this.props.store

    return (
      <div className={style.content}>
        <Action
          bordered={true}
          style={{ marginBottom: 24, height: 48, padding: '0' }}
          onChange={this.props.store.changeTab}
          active={key}
          options={[
            { title: `审核中(${statusCount.pendingCount || 0})`, value: '2' },
            {
              title: `审核未通过(${statusCount.rejectCount || 0})`,
              value: '3'
            }
          ]}
        />

        <div className={style.tContent}>
          <Table store={this.props.store} />
        </div>
      </div>
    )
  }
}
